import React, { useCallback, useEffect, useState } from "react";
import { Alert } from "antd";
import appSettings from "../../constants/app.constants";

import "./container.scss";
import { Link } from "react-router-dom";

const PageNotFound = () => {
	const [height, setHeight] = useState(0);
	const listener = useCallback(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
	}, [window.innerHeight, appSettings.windowHeightDelta]);

	useEffect(() => {
		setHeight(window.innerHeight - appSettings.windowHeightDelta);
		window.addEventListener("resize", listener);

		return () => {
			window.removeEventListener("resize", listener);
		};
	}, []);

	return (
		<div className="pageNotFound_container" style={{ height }}>
			<Alert
				className="error_message"
				type="error"
				message="Страница не найдена"
				description={
					<div className="error_message-text">
						<span>Возможно, ссылка более не актуальна, или в ней ошибка</span>
						<br />
						<Link to="/" className="error_message-link">
							На главную
						</Link>
					</div>
				}
				showIcon
			/>
		</div>
	);
};

export default PageNotFound;
